export const SET_GENBA_AI_VIEW = "SET_GENBA_AI_VIEW";
export const SET_GENBA_AI_SELECTED_ACTION = "SET_GENBA_AI_SELECTED_ACTION";
export const SET_GENBA_AI_VIEW_DETAILS = "SET_GENBA_AI_VIEW_DETAILS";
export const SET_GENBA_AI_IS_OPEN = "SET_GENBA_AI_IS_OPEN";
export const RESET_GENBA_AI_STATE = "RESET_GENBA_AI_STATE";
